module.exports = __webpack_public_path__ + "static/media/haute7D.866e011c.jpg";